import React from 'react';
import './styles.css';


const Button = () => {
  return (
    <div className="button-container">
      <button className="apply-button">APLICAR</button>
      <button className="clean-button">LIMPIAR</button>
    </div>
  )
}

export default Button